import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './TicketCard.css';

const TERMS_HREF = 'https://tickchak.co.il/terms';

interface TicketCardProps {
    top?: ReactNode;
    children: ReactNode;
    withLink?: boolean;
    hasFooter?: boolean;
    'data-cy'?: string;
}

function TicketCard({top, children, withLink = false, hasFooter = true, 'data-cy': dataCy = 'ticket-card'}: TicketCardProps) {
    const {t} = useTranslation('eTicket');
    return (
        <css.cardScaler>
            <css.cardInner data-cy={dataCy}>
                {top && <css.top>{top}</css.top>}
                <css.middle>{children}</css.middle>
                {hasFooter && (
                    <css.footer className={withLink ? 'with-link' : ''}>
                        {withLink && (
                            <css.terms
                                href={TERMS_HREF}
                                target="_blank"
                                rel="noreferrer"
                                data-cy="ticket-card-terms">
                                {t('termsOfUse')}
                            </css.terms>
                        )}
                        <css.logo />
                    </css.footer>
                )}
            </css.cardInner>
        </css.cardScaler>
    );
}

export default TicketCard;
